import { ITrendItemBase, IKPIValue } from '@opm/pages/CreativeTrends/types';
import {
  IUgcVideoItem as _IUgcVideoItem,
  toVideoCardItem as _toVideoCardItem,
} from '@opm/utils/videoAdapter';

// 从公共 utils 重导出，保留旧导入路径，统一字段映射逻辑
export type IUgcVideoItem = _IUgcVideoItem;
export const toVideoCardItem = _toVideoCardItem;

export type TStatusTab = 'hot' | 'rising' | 'new';
export type TViewMode = 'card' | 'table';

export interface IListMax {
  tweets_view: number;
  tweets_like: number;
  videos: number;
}

/**
 * UGC Trend 列表项
 *
 * 复用 CreativeTrends 的 ITrendItemBase 公共字段（game/topic/类目/ai_summary 等），
 * 在此扩展 UGC 业务专属的 KPI（tweets_view / tweets_like / videos）和 top_related_videos。
 */
export interface ITrendItem extends ITrendItemBase {
  tweets_view: IKPIValue;
  tweets_like: IKPIValue;
  videos: IKPIValue;
  top_related_videos?: _IUgcVideoItem[];
}

export type ITrendDetail = Omit<ITrendItem, 'top_related_videos'>;

export interface IUgcTrendsStats {
  hot: number;
  rising: number;
  new: number;
}

export interface ISortOption {
  value: string;
  text: string;
  order: 'asc' | 'desc';
}

export function trendKey(
  item?: {
    game_id?: string;
    topic?: string;
  } | null,
): string {
  if (!item) return '';
  return `${item.game_id || ''}__${item.topic || ''}`;
}
